import {
  Labeled,
  SimpleForm,
  TextField,
  TextInput,
  Create,
  useTranslate,
  ListButton,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  AutocompleteInput,
  ReferenceInput,
  NumberInput,
} from 'react-admin';
import { Box, Card, CardContent, FormHelperText, Grid } from '@mui/material';

const GroupRegCreate = () => {
  const translation = useTranslate();
  return (
    <Create
      title={<span>{translation('resources.group_regs.create_title')}</span>}
      component="div"
    >
      <Box maxWidth="50em">
        <Card>
          <ListButton sx={{ marginTop: '1rem', marginLeft: '1rem' }} />
          <SimpleForm>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Labeled source="id">
                    <TextField
                      source="id"
                      fontSize="1.4rem"
                      marginLeft=".6rem"
                      emptyText="Auto generated"
                    />
                  </Labeled>
                </Grid>
                <Grid item xs={12} md={6}>
                  <ReferenceInput source="ipv4" reference="available_ips">
                    <AutocompleteInput
                      optionText="id"
                      source="ipv4"
                      fullWidth
                      size="small"
                      helperText="resources.group_regs.fields.ipv4.helperText"
                      translateChoice={false}
                    />
                  </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Labeled source="ipv6_">
                    <TextField
                      source="ipv6_"
                      fontSize="1.4rem"
                      marginLeft=".6rem"
                      emptyText="Auto generated"
                    />
                  </Labeled>
                </Grid>
                <Grid item xs={12} md={12}>
                  <ArrayInput
                    source="macs"
                    isRequired
                    fullWidth
                    helperText="resources.group_regs.fields.macs.helperText"
                  >
                    <SimpleFormIterator fullWidth inline disableReordering>
                      <TextInput
                        source="mac"
                        helperText={false}
                        sx={{ marginRight: '.4rem', marginTop: '.4rem' }}
                      />
                      <TextInput
                        source="comment"
                        helperText={false}
                        sx={{ marginRight: '.4rem', marginTop: '.4rem' }}
                      />
                      <BooleanInput
                        source="dhcp"
                        helperText={false}
                        defaultValue={true}
                      />
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
                <Grid item xs={12} md={12}>
                  <BooleanInput
                    source="enabled"
                    isRequired
                    fullWidth
                    defaultValue={true}
                    helperText="resources.group_regs.fields.enabled.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="nextsrv"
                    fullWidth
                    helperText="resources.group_regs.fields.nextsrv.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="pxefile"
                    fullWidth
                    helperText="resources.group_regs.fields.pxefile.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextInput
                    source="annotation"
                    multiline
                    fullWidth
                    helperText="resources.group_regs.fields.annotation.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <ArrayInput
                    source="administrators"
                    isRequired
                    fullWidth
                    helperText="resources.group_regs.fields.administrators.helperText"
                  >
                    <SimpleFormIterator fullWidth inline disableReordering>
                      <TextInput
                        source="schacc"
                        helperText={false}
                        sx={{ marginRight: '.4rem', marginTop: '.4rem' }}
                      />
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
                <Grid item xs={12} md={4}>
                  <NumberInput
                    source="group_id"
                    multiline
                    fullWidth
                    helperText="resources.group_regs.fields.group_id.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextInput
                    source="justification"
                    multiline
                    fullWidth
                    helperText="resources.group_regs.fields.justification.helperText"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </SimpleForm>
        </Card>
      </Box>
    </Create>
  );
};

export default GroupRegCreate;
